import { Button } from "@mui/material";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import {
  CmpSelectField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpTypographyField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
import {
  fcheck_null_undefine_replace_empty,
  hasValueInErrorMessage,
  userBasedHideField,
} from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { SalesInvoice001_Loyalty_Search_Getrow_FULL } from "../../../Server/ApiV2";
import { Set_HeadObject_Set } from "../SliceDelieveryNote";
import { DelieveryNoteRo } from "../../../Redux/roStore";

// import { userBasedHideField } from "./../../../Configs/index";
export default function WmsSalesFooter({
  Salesman,
  SalesGroup,
  sFooterObj,
  fonChangeInputDiscount,
  fonChangeRounding,
  fOpenDiscountPercentageModal,
  fOpenSalesGroupModal,
  fonClickInputFocusRounding,
  fonClickInputBlurRounding,
  sErrorMsg,
  vRdxWmsHead,
  fonChangeSelectSalesMan,
  fonChangeSelectSalesGroup,
  fonChangeInputFooter,
  setShowModal,
  setShowModal2,
  setShowModal3,
  loyaltySearchbtn,
  dispatch,
}) {
  return (
    <div className="Wms-sales-invoice-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              className={userBasedHideField() ? "" : "hide-content"}
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Sales Group"}
                xtextDecoration="underline"
                xonClick={fOpenSalesGroupModal}
              />
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              className={userBasedHideField() ? "" : "hide-content"}
            >
              <CmpInputField
                xValue={vRdxWmsHead.A_SalesGroup}
                xType={"text"} // text/number/password
                xName={"A_SalesGroup_id"}
                xReadOnly={true}
              />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              md={8}
              lg={8}
              className={userBasedHideField() ? "" : "hide-content"}
            >
              <CmpSelectField
                xtabIndex="202"
                xLabelText="A_SalesGroup"
                xValue={vRdxWmsHead.A_SalesGroup}
                xOnChange={(e) => {
                  fonChangeSelectSalesGroup(e, SalesGroup);
                }}
                xName={"A_SalesGroup"}
                xData={SalesGroup}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_SalesGroup === "" ? false : true}
                xErrorMessage={sErrorMsg.A_SalesGroup}
                xDisable={false}
              />
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Sales Man"} />
            </Grid>
            <Grid item xs={10} sm={7} md={7}>
              <CmpSelectField
                xtabIndex="201"
                xLabelText="A_Buyer"
                xValue={vRdxWmsHead.A_Buyer}
                xOnChange={(e) => {
                  fonChangeSelectSalesMan(e, Salesman);
                }}
                xName={"A_Buyer"}
                xData={Salesman}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_Buyer === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Buyer}
                xDisable={false}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
              md={3}
              sx={{ paddingLeft: { md: "0px", sm: "4px", xs: "0px" } }}
            >
              <CmpTypographyField
                xonClick={setShowModal2}
                xcomponent={"span"}
                xText={"Add Custom Detail"}
                xtextDecoration="underline"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Note"} />
            </Grid>
            <Grid item xs={10} sm={7} md={7}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxWmsHead.Note}
                xType={"text"} // text/number/password
                xName={"Note"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInputFooter(e);
                }}
                xError={sErrorMsg.Note === "" ? false : true}
                xErrorMessage={sErrorMsg.Note}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
              md={3}
              sx={{ paddingLeft: { md: "0px", sm: "4px", xs: "0px" } }}
            >
              {/* <CmpTypographyField
                xonClick={setShowModal}
                xcomponent={"span"}
                xText={"Shipping Address"}
                xtextDecoration="underline"
              /> */}
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInputFooter(e);
                }}
                xError={sErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Narr}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} className="text-center">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={4} sm={4} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Gross Amount"} />
            </Grid>
            <Grid item xs={8} sm={8} md={8} lg={6}>
              <CmpInputField
                xValue={sFooterObj.A_GrossAmt}
                xType={"text"} // text/number/password
                xName={"A_GrossAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Discount"}
                xonClick={fOpenDiscountPercentageModal}
                xtextDecoration="underline"
              />
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              onDoubleClick={fOpenDiscountPercentageModal}
            >
              <CmpInputField
                xValue={vRdxWmsHead.A_DiscPerc}
                xType={"text"} // text/number/password
                xName={"A_DiscPerc"}
                xReadOnly={true}
                xOnChange={(e) => fonChangeInputDiscount(e)}
                xError={sErrorMsg.A_DiscPerc === "" ? false : true}
                xErrorMessage={sErrorMsg.A_DiscPerc}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={sFooterObj.A_TDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_TDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_LDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_LDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField xcomponent={"span"} xText={"FOC & Excise"} />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_FocAmt}
                xType={"text"} // text/number/password
                xName={"A_FocAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_NetExcise}
                xType={"text"} // text/number/password
                xName={"A_NetExcise"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Tax ,Cess & AddCess"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={sFooterObj.A_Tax}
                xType={"text"} // text/number/password
                xName={"A_Tax"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={sFooterObj.A_Tax2}
                xType={"text"} // text/number/password
                xName={"A_Tax2"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={3} lg={3}>
              <CmpInputField
                xValue={sFooterObj.A_AddCess}
                xType={"text"} // text/number/password
                xName={"A_AddCess"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rounding & Net_Amt"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xtabIndex="205"
                xValue={vRdxWmsHead.A_Rounding}
                xType={"number"} // text/number/password
                xName={"A_Rounding"}
                xReadOnly={false}
                xOnChange={(e) => fonChangeRounding(e)}
                xError={sErrorMsg.A_Rounding === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Rounding}
                xonFocus={(e) => {
                  fonClickInputFocusRounding(e);
                }}
                xonBlur={(e) => {
                  fonClickInputBlurRounding(e);
                }}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_LandVal}
                xType={"text"} // text/number/password
                xName={"A_LandVal"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg.A_Rounding == "" ? false : true}
                xErrorMessage={sErrorMsg.A_Rounding}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={12}>
              {/* <Button
                onClick={setShowModal3}
                size="small"
                variant="contained" // or "outlined", "text" based on your need
                sx={{
                  backgroundColor: "gray",
                  width: "100%",
                  color: "white", // Ensures the text is visible on the gray background
                  "&:hover": {
                    backgroundColor: "#6c757d", // Slightly darker gray on hover
                  },
                }}
              >
                Dispatch Detail
              </Button> */}
              {/* {!userBasedHideField() &&  <Button
              size="small"
                variant="contained" // or "outlined", "text" based on your need
                sx={{
                  backgroundColor: "gray",
                  width: "100%",
                  color: "white", // Ensures the text is visible on the gray background
                  "&:hover": {
                    backgroundColor: "#6c757d", // Slightly darker gray on hover
                  },
                }}
              >
                Item narration
              </Button>} */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
